import React from 'react';
import LoadingSkeleton from '../LoadingSkeleton';

function CardWithBody({children, loading, height}) {
    return <div className="card">
        <div className="card-body">
            {
                loading ? <LoadingSkeleton height={height}/> : children
            }
        </div>
    </div>
}

export default CardWithBody
